import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type {
  LicenseCheckResult,
  LicenseQaScenario,
} from '@cdw-ae/common-data';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PlatformLicensingService {
  private readonly http = inject(HttpClient);

  // The platform-auth interceptor attaches the Bearer token + x-cdw-app-name,
  // so no headers are needed here.
  /**
   * Check a domain's Chargify license state. `refresh` busts the 24h cache
   * first — the "customer just renewed, unblock them now" remedy.
   */
  checkLicense(
    domain: string,
    refresh = false
  ): Observable<LicenseCheckResult> {
    const url = `${environment.urls.backendApi}/platform/licensing/check`;
    let params = new HttpParams().set('domain', domain);
    if (refresh) {
      params = params.set('refresh', 'true');
    }
    return this.http.get<LicenseCheckResult>(url, { params });
  }

  /**
   * INTERNAL QA (EDUS-2726): seed a license scenario for an internal test
   * domain so the next login resolves the matching verdict. Short-TTL,
   * self-healing. Backend allowlists both domain and scenario.
   */
  setQaOverride(
    domain: string,
    scenario: LicenseQaScenario
  ): Observable<LicenseCheckResult> {
    const url = `${environment.urls.backendApi}/platform/licensing/qa-override`;
    return this.http.post<LicenseCheckResult>(url, { domain, scenario });
  }

  /** Clear a QA override — the domain reverts to real Chargify on next read. */
  clearQaOverride(domain: string): Observable<{ cleared: true }> {
    const url = `${environment.urls.backendApi}/platform/licensing/qa-override/clear`;
    return this.http.post<{ cleared: true }>(url, { domain });
  }
}
